import { render, staticRenderFns } from "./WidgetProductReviewsListV3Mobile.vue?vue&type=template&id=1d30f18a"
import script from "./WidgetProductReviewsListV3Mobile.vue?vue&type=script&lang=js"
export * from "./WidgetProductReviewsListV3Mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports